import i18n from 'services/i18n'
export function initObjectWithKeys (keys, valueCb) {
    return keys.reduce((object, key) => {
        object[key] = valueCb()
        return object
    }, {})
}

export function initObjectWithKeysAndArrayAsDefaultValue (keys) {
    return initObjectWithKeys(keys, () => [])
}

export const doSearchDefaultTimeoutDuration = 100
export const searchDebounceDuration = 15

export function combineFiltersWithFacets (currentFilters, currentFacets, filterKeys) {
    const result = initObjectWithKeysAndArrayAsDefaultValue(filterKeys)
    filterKeys.forEach(filterKey => {
        const filters = currentFilters[filterKey] ?? []
        const facetValues = currentFacets[filterKey] ?? []
        const filterValues = filters.map(filterItem => filterItem.value)
        const filterItemsWithCounts = filters.map(filterItem => {
            const foundFacet = facetValues.find(facetValue => facetValue.value === filterItem.value)
            return {
                ...filterItem,
                count: foundFacet?.count ?? 0,
                selected: true
            }
        })

        const filterItemsFromFacets =
            facetValues
                .filter(facetValue => filterValues.indexOf(facetValue.value) === -1)
                .map(facetItem => ({
                    ...facetItem,
                    selected: false
                }))
        result[filterKey] = []
            .concat(filterItemsWithCounts, filterItemsFromFacets)
        result[filterKey].forEach(item => {
            if (filterKey === 'memberStatus' && item.value === 'active') {
                item.label = i18n.t(item.label)
            }
            if (item.value === null) {
                item.label = i18n.t('ReportingFilters.not_set')
            }
            if (!item.hasOwnProperty('label') || item.label === null) {
                item.label = item.value.toString()
            }
        })
        result[filterKey].sort((itemA, itemB) => {
            if (itemA.value === null) {
                return 1
            } else if (itemB.value === null) {
                return -1
            }
            return itemA.label.localeCompare(itemB.label)
        })
    })
    return result
}
